<template>
    <section>
        <canvas ref="barChart"></canvas>
    </section>
</template>

<script>
    import Chart from 'chart.js'

    export default {
        name: 'BarChart',
        props: {
            data: {
                default: {},
                type: Array
            },
            label: {
                default: '',
                type: String
            },
            backgroundColor: {
                default: 'rgba(54, 162, 235, 0.2)',
                type: String
            },
            borderColor: {
                default: 'rgba(54, 162, 235, 1)',
                type: String
            },
            unit: {
                default: '',
                type: String
            }
        },
        data () {
            return {
                barChart: null
            }
        },
        watch: {
            data (data) {
                this.drawBarChart()
            }
        },
        methods: {
            drawBarChart () {
                const ctx = this.$refs.barChart
                this.barChart = new Chart(ctx, {
                    type: 'horizontalBar',
                    data: {
                        labels: this.data.map(x => x[0]),
                        datasets: [
                            {
                                label: this.label,
                                backgroundColor: this.backgroundColor,
                                borderColor: this.borderColor,
                                data: this.data.map(x => x[1])
                            }
                        ]
                    },
                    options: {
                        legend: {
                            display: false
                        },
                        tooltips: {
                            callbacks: {
                                label: (tooltipItems, data) => {
                                    return data.datasets[tooltipItems.datasetIndex].label + ': ' + tooltipItems.xLabel + this.unit
                                }
                            }
                        },
                        scales: {
                            xAxes: [{
                                ticks: {
                                    userCallback: (item) => {
                                        return item + this.unit
                                    }
                                }
                            }]
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/BarChart.vue